var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2C16 1.4 15.6 1 15 1H1C0.4 1 0 1.4 0 2V14C0 14.6 0.4 15 1 15H15C15.6 15 16 14.6 16 14V2ZM14 3V5H2V3H14ZM2 13V7H14V13H2Z",
    fill: "#393B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9H10C9.5 9 9 9.5 9 10C9 10.5 9.5 11 10 11H12C12.5 11 13 10.5 13 10C13 9.5 12.5 9 12 9Z",
    fill: "#393B48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.a95be00fdfdff388ad1a88f270366f87.svg";
export { ForwardRef as ReactComponent };